import React from 'react'
import styled from 'styled-components'

const NewLabelText = styled.div`
  background: ${props => props.theme.regional.newLabelBackground};
  border: 1px solid ${props => props.theme.regional.newLabelBorder};
  border-radius: 4px;
  bottom: 3.5px;
  color: ${props => props.theme.regional.color};
  font-size: 12px;
  font-weight: bold;
  height: 20px;
  line-height: 18px;
  padding: 0 8px;
  font-family: Arial,lucida,helvetica,sans-serif;
  margin-top: -5px;
  z-index: 20;
`

export const NewLabelDesktop = () => <NewLabelText>nové</NewLabelText>
